import React from "react";
import SecondaryNavbar from "../HomePage/Navbar/SecondaryNavbar";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useLanguage } from "../../context/LanguageContext";
import dataEn from "../../languages/en/emailNotification.json";
import dataTh from "../../languages/th/emailNotification.json";

const EmailNotificationPage = () => {
  const { selectedLanguage } = useLanguage(); // Use the context
  const data = selectedLanguage === "en" ? dataEn : dataTh;
  const location = useLocation();
  console.log(location.state);

  //make defualut
  const [forgotpass, setForgotpass] = useState(
    location.state.forgotpass || false
  );

  const navigate = useNavigate();
  const handleOpenEmail = () => {
    // navigate("/accountActivation");

    forgotpass ? navigate("/createNewPass") : navigate("/accountActivation");

    // Open Gmail URL
    window.open("https://mail.google.com/");
  };

  return (
    <div className="relative">
      <SecondaryNavbar />
      <div className="flex flex-col items-center mt-20 h-screen ">
        {/* Email Sent Image */}
        <img
          src={process.env.PUBLIC_URL + "/Logo/Desktop/mail.png"}
          alt="Email Sent"
          className="w-32 h-auto mb-8"
        />

        {/* Header */}
        <h2 className="text-3xl font-semibold text-gray-800">{data.title}</h2>

        {/* Content */}

        {forgotpass ? (
          <p className="text-gray-400 text-center mt-4 mb-8 text-sm">
            {data.forgotPass[0]} <br /> {data.forgotPass[1]}
          </p>
        ) : (
          <p className="text-gray-400 text-center mt-4 mb-8 text-sm">
            {data.forgotPass[2]} <br /> {data.forgotPass[3]}
          </p>
        )}

        {/* Button */}
        <button
          type="submit"
          className={`w-1/2 bg-gradient-to-r from-primary-900 to-primary-600 text-white py-4 rounded-full font-bold hover:bg-blue-600
            `}
          onClick={handleOpenEmail}
        >
          {data.submit}
        </button>

        <div className="text-sm">
          <p className="mt-8 text-center text-gray-600">
            {data.newAccount}
            <a
              className="font-semibold text-primary-900 cursor-pointer"
              onClick={(e) => {
                navigate("/register");
              }}
            >
              {data.register}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailNotificationPage;
